import axiosInstance from "core/api/axiosInstance";
import {
  commerceList,
  commerceAttributes,
  commercePayload,
  commerceWriteSucceeded,
  commerceWriteRejected,
  commerceStats,
} from "../comercios/model/commerceModel";
const message = (error) =>
  error.response?.data?.message ||
  error.response?.data?.error ||
  error.response?.data?.msm ||
  (error.request ? "No se pudo conectar con el servidor." : error.message) ||
  "No se pudo completar la solicitud.";
async function read(path, normalize, options = {}) {
  try {
    const { data } = await axiosInstance.get(
      `/api/automatization/jarvis/${path}`,
      options.signal ? { signal: options.signal } : {}
    );
    if (data?.success === false || data?.error)
      throw new Error(data.error || data.message || "El servidor rechazó la consulta.");
    const result = normalize(data);
    return {
      success: true,
      data: result,
      total: Array.isArray(result) ? result.length : undefined,
    };
  } catch (error) {
    if (error.code === "ERR_CANCELED" || error.name === "AbortError")
      return { success: false, cancelled: true };
    return { success: false, error: message(error) };
  }
}
export const getComerciosService = (options) => read("get-list-commerce", commerceList, options);
export const getComerciosAttributesService = (options) =>
  read("get-list-commerce-attribute", commerceAttributes, options);
export const getComerciosAddService = (options) =>
  read("get-list-commerce-add", (data) => commerceList(data, true), options);
async function write(form, method, path) {
  let sent = false;
  try {
    const payload = commercePayload(form);
    sent = true;
    const { data } = await axiosInstance[method](`/api/automatization/jarvis/${path}`, payload);
    if (!commerceWriteSucceeded(data))
      return {
        success: false,
        uncertain: !commerceWriteRejected(data),
        error:
          data?.error ||
          data?.message ||
          data?.response?.error ||
          data?.response?.message ||
          "El servidor no confirmó que el comercio se haya guardado.",
      };
    return {
      success: true,
      data: data.response ?? data,
      message: "Comercio guardado correctamente.",
    };
  } catch (error) {
    return { success: false, error: message(error), uncertain: sent && !error.response };
  }
}
export const createComercioService = (form) => write(form, "post", "create-commerce");
export const updateComercioService = (form) => write(form, "put", "update-commerce");
export const getComerciosActivosService = async () => {
  const result = await getComerciosService();
  if (!result.success) return result;
  const data = result.data.filter((row) => row.activo === true);
  return { ...result, data, total: data.length };
};
export const getComerciosPorTipoService = async (type) => {
  const result = await getComerciosService();
  if (!result.success) return result;
  const data = result.data.filter(
    (row) => row.tipoComercio.toLowerCase() === String(type).toLowerCase()
  );
  return { ...result, data, total: data.length };
};
export const buscarComerciosService = async (search) => {
  const result = await getComerciosService();
  if (!result.success) return result;
  const data = result.data.filter((row) =>
    row.nombre.toLowerCase().includes(String(search).trim().toLowerCase())
  );
  return { ...result, data, total: data.length };
};
export const getComerciosStatsService = async () => {
  const result = await getComerciosService();
  return result.success ? { success: true, data: commerceStats(result.data) } : result;
};
